const treatmentStatus = (startDate) => {
  const treatmentStatus = [];
  for (let i = 0; i < 12; i++) {
    const newObj = {};
    const treatmentList = [];
    for (let j = 0; j < 7; j++) {
      let startDateParse = new Date(
        startDate.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")
      );
      let addDate = 7 * (i + 1) - (7 - (j + 1));
      startDateParse.setDate(startDateParse.getDate() + (addDate - 1));
      const month =
        startDateParse.getMonth() + 1 < 10
          ? "0" + String(startDateParse.getMonth() + 1)
          : startDateParse.getMonth() + 1;
      const date =
        startDateParse.getDate() < 10
          ? "0" + String(startDateParse.getDate())
          : startDateParse.getDate();
      const treatment = {};
      treatment.status = 0;
      treatment.title = month + "/" + date;
      treatment.dayNum = "";
      treatmentList.push(treatment);
    }
    newObj.weekNum = i + 1;
    newObj.days = treatmentList;
    treatmentStatus.push(newObj);
  }
  return treatmentStatus;
};

export default treatmentStatus;
